import Vue from 'vue'
import Router from 'vue-router'
import Session from '@/components/Session'
import Dashboard from '@/components/dashboard/Dashboard'

import Home from '@/components/dashboard/children/Home'
import KeyAdministration from '@/components/dashboard/children/Key'
import Pricing from '@/components/dashboard/children/Pricing'
import UsersAdministration from '@/components/dashboard/children/Users'
import KeyBuying from '@/components/dashboard/children/Buykeys'
import OwnerLocks from '@/components/dashboard/children/Locks'
import ForgotPass from '@/components/utilities/Forgot'
import UpdateOwner from '@/components/dashboard/children/Update'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Session',
      component: Session
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      children: [
        {
          path:'',
          component: UsersAdministration
        },
        {
          path: 'home',
          name: 'home',
          component: Home
        },
        {
          path: 'add-key',
          name: 'user',
          component: KeyAdministration
        },
        {
          path: 'pricing',
          name: 'pricing',
          component: Pricing
        },
        {
          path: 'view-users',
          name: 'users',
          component: UsersAdministration
        },
        {
          path: 'owner-locks',
          name: 'owner-locks',
          component: OwnerLocks
        },
        {
          path: 'buy-keys',
          name: 'users',
          component: KeyBuying
        },
        {
          path: 'update-user',
          name: 'users',
          component: UpdateOwner
        },
      ]
    },
    {
      path: '/forgot-password',
      name: 'forg-pass',
      component: ForgotPass
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js